/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState, useEffect} from 'react';
import PageBox from "../layouts/pageBox";
import {ReactComponent as File} from "../assets/img/icons/file.svg";
import {ReactComponent as Close} from "../assets/img/forms/close.svg";
import selectedImage from "../assets/img/forms/selected-car.jpg";
import {Link} from "react-router-dom";
import {useFieldArray, useForm} from "react-hook-form";
import {ReactComponent as Delete} from "../assets/img/forms/delete.svg";
import {ReactComponent as AddPart} from "../assets/img/forms/add-part.svg";
import {ReactComponent as CheckboxEmpty} from "../assets/img/forms/checkbox-empty.svg";
import {ReactComponent as CheckboxFull} from "../assets/img/forms/checkbox-full.svg";
import {useTranslation} from "react-i18next";

const PartRequest = () => {

    const [imagesArray, SetImagesArray] = useState([]);
    const [partImagesArray, SetpartImagesArray] = useState([]);
    const { t, i18n } = useTranslation();

    //Todo να φτιαχτει η axios που θα ελεγχει το usertoken.

    const data = {
        title: 'Part Request',
        subtitle: 'Submit your part request to our Professional DismantlerLayout Network '
    };

    const options = [
        {value : 'Audi', label : 'Audi'},
        {value : 'Audi', label : 'Audi'},
        {value : 'Audi', label : 'Audi'},
    ];
    const options2 = [
        {value : 'A3', label : 'A3'},
        {value : 'A4', label : 'A4'},
        {value : 'A8', label : 'A8'},
    ];
    const options3 = [
        {value : '2003', label : '2003'},
        {value : '2004', label : '2004'},
        {value : '2005', label : '2005'},
    ];
    const inlineCheckboxs = [
        { label: 'Petrol', value: 'petrol'},
        { label: 'Diesel', value: 'diesel'},
        { label: 'Electric', value: 'electric'},
        { label: 'Hybrid', value: 'hybrid'},
        { label: 'Other', value: 'other'}
    ];
    const engineCapacity = [
        { label: '1000cc', value: '1000cc'},
        { label: '1400cc', value: '1400cc'},
        { label: '1600cc', value: '1600cc'},
        { label: '2000cc', value: '2000cc'},
    ];
    const Bodytype = [
        { label: 'Hatchback', value: 'hatchback'},
        { label: 'Sedan', value: 'sedan'},
        { label: 'SUV', value: 'SUV'},
    ];
    const Transmition = [
        { label: 'Manual', value: 'Manual'},
        { label: 'Automatic', value: 'Automatic'},
        { label: 'Other', value: 'Other'},
    ];
    const ApproveLabel = () => (
        <>
            Checking here and continuing, I agree to the <strong>&nbsp;Autorecparts&nbsp;</strong> <Link to={`/${i18n.language}/terms`}> Terms of Use. </Link>
        </>
    );
    const { control, register, handleSubmit, watch, formState: { errors }, trigger, clearErrors } = useForm({
        mode: "onChange",
        defaultValues: {
            parts: [{ typepart: "", addnote: "" }]
        }
    });
    const watchVehicleModel = watch("vehicleModel", false);
    const watchMakeModel = watch("makeModel", false);
    const watchYearModel = watch("yearModel", false);
    const watchFueltype = watch("fueltype", false);
    const watchEngineCapacity = watch("engineCapacity", false);
    const watchBodytype = watch("bodytype", false);
    const watchTransmition = watch("transmition", false);
    const watchCarimage = watch("carimage", false);

    const { fields, append, remove } = useFieldArray({
        control,
        name: "parts",
    });

    const appendParts = () => {
        append(
            {typepart: "", addnote: "", image: ''},
        );

        if (errors.parts?.type === "min") {
            clearErrors("parts"); // always clear errors when there is add action.
        }
    };

    const onSubmit = data => console.log(data);

    function changeHundler(e){
        //const file = e.target.value;
        const files = e.target.files;
        const name = e.target.files[0].name;
        //SetImagesArray([...imagesArray, { 'url' : file, 'name': name }]);
        SetImagesArray([...imagesArray, ...files]);
    }

    function partimageOnChange(e, index){

        const files = Array.from(e.target.files);
        let newArr = [...partImagesArray];
        newArr[index] = files;
        SetpartImagesArray(newArr);
    }

    function deleteImage(index){
        const _array = [...imagesArray];
        _array.splice(index, 1);
        SetImagesArray(_array);
    }


    useEffect( ()=>{
        console.log(imagesArray);
    },[imagesArray] );

    useEffect( ()=>{
        console.log(partImagesArray);
    },[partImagesArray] );

    return (
        <PageBox data={data}>
            <div className='page-body'>
                <div className='PartRequest--container'>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='PartRequest__section'>
                            <div className='PartRequest__header'>
                                <div className='PartRequest__num'>1</div>
                                <div className='PartRequest__title big--title'>Select your vehicle info</div>
                            </div>
                            <div className='PartRequest__body'>

                                <div className='row'>
                                    <div className='col-md-6'>

                                        <div className='PartRequest__box'>
                                            <div className="form-row">
                                                <div className="form-group col">

                                                    <label htmlFor='vehicleModel'>Vehicle Model</label>
                                                    <select id='vehicleModel' className='form-control' defaultValue="" {...register("vehicleModel", {required: 'Required Field'})}>
                                                        <option value="" disabled>Επιλέξτε</option>
                                                        {options.map((option, i) => <option key={i} value={option.value}>{option.label}</option>)}
                                                    </select>
                                                    { errors.vehicleModel && <small className="text-danger">{errors.vehicleModel?.message}</small>}

                                                </div>
                                                <div className="form-group col">

                                                    <label htmlFor='makeModel'>Make</label>
                                                    <select id='makeModel' className='form-control' defaultValue="" {...register("makeModel", {required: 'Required Field'})}>
                                                        <option value="" disabled>Επιλέξτε</option>
                                                        {options2.map((option, i) => <option key={i} value={option.value}>{option.label}</option>)}
                                                    </select>
                                                    { errors.makeModel && <small className="text-danger">{errors.makeModel?.message}</small>}

                                                </div>
                                                <div className="form-group col">

                                                    <label htmlFor='yearModel'>Year</label>
                                                    <select id='yearModel' className='form-control' defaultValue="" {...register("yearModel", {required: 'Required Field'})}>
                                                        <option value="" disabled>Επιλέξτε</option>
                                                        {options3.map((option, i) => <option key={i} value={option.value}>{option.label}</option>)}
                                                    </select>
                                                    { errors.yearModel && <small className="text-danger">{errors.yearModel?.message}</small>}

                                                </div>
                                            </div>
                                        </div>

                                        <div className={`PartRequest__box ${  watchVehicleModel && watchMakeModel && watchYearModel ? "" : "fog"}`}>
                                            <div className="form-row">
                                                <div className='form-group col'>
                                                    <div className='checkboxes'>
                                                        <div className='checkboxes__label'>Fuel Type</div>
                                                        <div className='checkboxes__body'>
                                                            {
                                                                inlineCheckboxs.map( (checkbox, index) => (
                                                                    <div className="form-check form-check-inline" key={index}>
                                                                        <input id={`fueltype_${index}`} className="form-check-input" type="radio" {...register("fueltype" )} />
                                                                        <label className="form-check-label" htmlFor={`fueltype_${index}`}>{checkbox.label}</label>
                                                                    </div>
                                                                ) )
                                                            }
                                                        </div>
                                                        { errors.fueltype && <small className="text-danger">{errors.fueltype?.message}</small>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={`PartRequest__box ${  watchFueltype ? "" : "fog"}`}>
                                            <div className="form-row">
                                                <div className="form-group col-lg-6">

                                                    <label htmlFor='vehicleModel'>Engine Capacity</label>
                                                    <select id='vehicleModel' className='form-control' defaultValue="" {...register("engineCapacity")}>
                                                        <option value="" disabled>Επιλέξτε</option>
                                                        {engineCapacity.map((option, i) => <option key={i} value={option.value}>{option.label}</option>)}
                                                    </select>
                                                    { errors.engineCapacity && <small className="text-danger">{errors.engineCapacity?.message}</small>}

                                                </div>
                                                <div className="form-group col-lg-6 d-flex justify-content-lg-end">
                                                    <div className='checkboxes'>
                                                        <div className='checkboxes__label'>Bodytype</div>

                                                        <div className='checkboxes__body'>
                                                            {
                                                                Bodytype.map( (checkbox, index) => (
                                                                    <div className="form-check form-check-inline" key={index}>
                                                                        <input id={`bodytype_${index}`} className="form-check-input" type="radio" {...register("bodytype" )} />
                                                                        <label className="form-check-label" htmlFor={`bodytype_${index}`}>{checkbox.label}</label>
                                                                    </div>
                                                                ) )
                                                            }
                                                        </div>
                                                        { errors.bodytype && <small className="text-danger">{errors.bodytype?.message}</small>}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={`PartRequest__box ${  watchEngineCapacity && watchBodytype ? "" : "fog"}`}>
                                            <div className="form-row">
                                                <div className='form-group col'>

                                                    <div className='checkboxes'>
                                                        <div className='checkboxes__label'>Τransmition</div>

                                                        <div className='checkboxes__body'>
                                                            {
                                                                Transmition.map( (checkbox, index) => (
                                                                    <div className="form-check form-check-inline" key={index}>
                                                                        <input id={`transmition_${index}`} className="form-check-input" type="radio" {...register("transmition" )} />
                                                                        <label className="form-check-label" htmlFor={`transmition_${index}`}>{checkbox.label}</label>
                                                                    </div>
                                                                ) )
                                                            }
                                                        </div>
                                                        { errors.transmition && <small className="text-danger">{errors.transmition?.message}</small>}

                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div className={`PartRequest__box ${  watchTransmition ? "" : "fog"}`}>
                                            <div className='form-group'>

                                                <label htmlFor='VinNumber'>Vin Number</label>
                                                <input id='VinNumber' className="form-control" type="text" {...register("VinNumber" )} />
                                                {/*{ props.error && <small className="text-danger">{props.error}</small>}*/}
                                                { errors.VinNumber && <small className="text-danger">{errors.VinNumber?.message}</small>}

                                            </div>
                                        </div>

                                        <div className={`PartRequest__box ${  watchTransmition ? "" : "fog"}`}>
                                            <div className='form-group'>

                                                <label htmlFor='customtrim'>Trim</label>
                                                <input id='customtrim' className="form-control" type="text" {...register("Trim" )} />
                                                { errors.Trim && <small className="text-danger">{errors.Trim?.message}</small>}

                                            </div>
                                        </div>

                                    </div>
                                    <div className='col-md-6'>

                                        <div className='PartRequest__box'>
                                            <div className='PartRequest__sub-title'>Upload your car images</div>
                                            <div className="input-group">
                                                <div className="custom--file">

                                                    <input id="validatedInputGroupCustomFile" type="file" multiple className="custom-file-input" {...register("carimage")} onChange={changeHundler} />

                                                    <label className="file-label" htmlFor="validatedInputGroupCustomFile">
                                                        <File/>Attach files
                                                    </label>
                                                    <span className='custom--file__small'>.jpg or .png (2MB / file)</span>
                                                </div>
                                            </div>

                                            <div className='selectedImages'>
                                                {imagesArray.map((item, index) =>
                                                    <div className='selectedImages__item' key={index}>
                                                        <div className='selectedImages__inner'>
                                                            <img src={selectedImage} alt={item.name} />
                                                        </div>
                                                        <span className='selectedImages__close' onClick={ () => {deleteImage(index)} }><Close/></span>
                                                    </div>
                                                )}
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='PartRequest__section'>
                            <div className='PartRequest__header'>
                                <div className='PartRequest__num'>2</div>
                                <div className='PartRequest__title big--title'>What Parts do you need</div>
                            </div>
                            <div className='PartRequest__body'>

                                <div className='fieldsets'>

                                    {fields.map((part, partIndex) => (


                                        <fieldset key={part.id} className="fieldsets__item" >
                                            <div className='btn fieldset-delete' onClick={() => {remove(partIndex); trigger();}}><Delete/></div>
                                            <div className=" legend text--title">Part #{partIndex + 1}</div>
                                            <div className="row">
                                                <div className='form-group col-md-4'>
                                                    <label htmlFor=''>Type Part*</label>
                                                    <input
                                                        id=''
                                                        className="form-control"
                                                        type="text"
                                                        control={control}
                                                        defaultValue=""
                                                        {...register(`parts[${partIndex}].typepart`)}
                                                    />
                                                    {/*{ errors.typepart && <small className="text-danger">{errors.typepart?.message}</small>}*/}
                                                </div>
                                                <div className='form-group col-md-8'>
                                                    <label htmlFor=''>Add a note</label>
                                                    <input
                                                        id=''
                                                        className="form-control"
                                                        type="text"
                                                        control={control}
                                                        defaultValue=""
                                                        {...register(`parts[${partIndex}].addnote`)}
                                                    />
                                                    {/*{ errors.addnote && <small className="text-danger">{errors.addnote?.message}</small>}*/}
                                                </div>
                                            </div>

                                            <div className="input-group inline-file">
                                                <div className='PartRequest__sub-title'>Upload your car images</div>
                                                <div className="custom--file">
                                                    <input id={`partImage--${partIndex}`} type="file" multiple className="custom-file-input" {...register("partimage")} onChange={ (e) => { partimageOnChange(e, partIndex) } } />
                                                    <label className="file-label" htmlFor={`partImage--${partIndex}`}>
                                                        <File/>Attach files
                                                    </label>
                                                    <span className='custom--file__small'>.jpg or .png (2MB / file)</span>
                                                </div>

                                                    { partImagesArray.map( (item, key, index) => {
                                                        if( parseInt(key)  === parseInt(partIndex) ){
                                                            return(
                                                                <div className='selectedImages selectedImages--small' key={index}>
                                                                {item.map((item2, index2) => {
                                                                        return (
                                                                            <div className='selectedImages__item' key={index2}>
                                                                                <div className='selectedImages__inner'>
                                                                                    <img src={selectedImage} alt={item2.name} />
                                                                                </div>
                                                                                <span className='selectedImages__close'><Close/></span>
                                                                            </div>
                                                                        );
                                                                })}
                                                                </div>
                                                            )
                                                        }
                                                    } ) }

                                                {/*<div className='selectedImages selectedImages--small'>*/}
                                                {/*    <div className='selectedImages__item'>*/}
                                                {/*        <div className='selectedImages__inner'>*/}
                                                {/*            <img src={selectedImage} alt='selectedImage' />*/}
                                                {/*        </div>*/}
                                                {/*        <span className='selectedImages__close'><Close/></span>*/}
                                                {/*    </div>*/}
                                                {/*    <div className='selectedImages__item'>*/}
                                                {/*        <div className='selectedImages__inner'>*/}
                                                {/*            <img src={selectedImage} alt='selectedImage' />*/}
                                                {/*        </div>*/}
                                                {/*        <span className='selectedImages__close'><Close/></span>*/}
                                                {/*    </div>*/}
                                                {/*    <div className='selectedImages__item'>*/}
                                                {/*        <div className='selectedImages__inner'>*/}
                                                {/*            <img src={selectedImage} alt='selectedImage' />*/}
                                                {/*        </div>*/}
                                                {/*        <span className='selectedImages__close'><Close/></span>*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}

                                            </div>

                                        </fieldset>
                                    ))}

                                </div>

                                <div className="form-group d-flex justify-content-center pt-5">
                                    <div className='btn btn-icon btn-icon-left btn--add-part' onClick={appendParts}><AddPart/>Add another part</div>
                                </div>


                            </div>
                        </div>

                        <div className='PartRequest__section'>
                            <div className='PartRequest__header'>
                                <div className='PartRequest__num'>3</div>
                                <div className='PartRequest__title big--title'>Your Contact details</div>
                            </div>
                            <div className='PartRequest__body'>

                                <fieldset className="">
                                    <div className="row">
                                        <div className='form-group col-md-6'>
                                            <label htmlFor='fname'>Name*</label>
                                            <input id='fname' className="form-control" type="text" {...register("fname",{required: 'Required Field'} )} />
                                            { errors.fname && <small className="text-danger">{errors.fname?.message}</small>}
                                        </div>
                                        <div className='form-group col-md-6'>
                                            <label htmlFor='formemail'>Email*</label>
                                            <input id='formemail' className="form-control" type="text" {...register("formemail", {
                                                required: 'Required Field',
                                                pattern: {
                                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                    message: 'Please enter a valid email',
                                                }} )} />
                                            { errors.formemail && <small className="text-danger">{errors.formemail?.message}</small>}
                                        </div>
                                    </div>
                                </fieldset>

                                <div className="form-group d-flex justify-content-lg-end align-items-end pt-5" style={{ flexDirection: 'column' }}>

                                    <label className="custom-checkbox  custom-checkbox--approve">
                                        <input type="checkbox" {...register("approve", {required: 'Required Field'} )}/>
                                        <span className="custom-checkbox__icon custom-checkbox__empty"><CheckboxEmpty/></span>
                                        <span className="custom-checkbox__icon custom-checkbox__checked"><CheckboxFull/></span>
                                        <ApproveLabel/>
                                    </label>
                                    { errors.approve && <small className="form-error text-danger">{errors.approve?.message}</small>}

                                </div>


                                <div className="form-group d-flex justify-content-lg-end pt-2">
                                    <button className="btn btn-primary" type="submit">Submit your request</button>
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </PageBox>
    );
};

export default PartRequest;
